import { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";

/**
 * Handles OAuth callback from backend
 * Extracts token from URL, saves to localStorage, and redirects to intended route
 */
const LoginCallback = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  useEffect(() => {
    const token = searchParams.get("token");
    const redirect = searchParams.get("redirect");

    if (token) {
      // Save token to localStorage
      localStorage.setItem("token", token);

      // Redirect to intended route or home
      const redirectPath = redirect || "/";
      navigate(redirectPath, { replace: true });
    } else {
      // No token in URL, redirect to home
      console.warn("No token found in OAuth callback");
      navigate("/", { replace: true });
    }
  }, [searchParams, navigate]);

  return (
    <div className="flex items-center justify-center min-h-screen">
      <div className="text-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-white mx-auto mb-4"></div>
        <p className="text-white">Completing login...</p>
      </div>
    </div>
  );
};

export default LoginCallback;

